import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TabControlComponent } from '../../../shared/controls/tab-control/tab-control.component';
import { TabPageComponent } from '../../../shared/controls/tab-control/tab-page.component';
import { AutoCompleteDropdownComponent } from '../../../shared/controls/auto-complete-dropdown/auto-complete-dropdown.component';
import { ReportParameter } from '../../../shared/models/report-parameter.model';
import { ReportConstants } from '../../../shared/constants/report.constants';

import { PolicyGroupService, PeriodService, AllPeriodItem, AllPolicyGroupItem } from '../../../../service/proxy';

@Component({
    selector: 'shared-debtor-by-policy-parameters',
    templateUrl: './shared-debtor-by-policy-parameters.component.html',
    styleUrls: ['./shared-debtor-by-policy-parameters.component.scss'],

    imports: [
        CommonModule,
        FormsModule,
        TabControlComponent,
        TabPageComponent,
        AutoCompleteDropdownComponent,
    ],

    providers: [
        PolicyGroupService,
        PeriodService,
    ]
})
export class SharedDebtorByPolicyParametersComponent implements OnInit {
    public isSaving: boolean = false;
    public formSubmitted: boolean = false;

    public periods: AllPeriodItem[] = [];
    public policyGroups: AllPolicyGroupItem[] = [];

    public selectedPolicyGroupId: number | undefined = undefined;
    public selectedPeriodId: number | undefined = undefined;

    constructor(
        private router: Router,
        private policyGroupService: PolicyGroupService,
        private periodService: PeriodService,
    ) {}

    ngOnInit(): void {
        this.getPeriodsForLookup();
        this.getPolicyGroupsForLookup();
    }

    getPeriodsForLookup(): void {
        this.periodService.getAllPeriods()
            .subscribe((data) => {
                this.periods = data.results || [];
            }
        );
    }

    getPolicyGroupsForLookup(): void {
        this.policyGroupService.getAllPolicyGroups()
            .subscribe((data) => {
                this.policyGroups = data.results || [];
            }
        );
    }

    displayPeriod(option: any): string {
        const paddedMonth = ('0' + option?.month).slice(-2);
        return `${option?.year}-${paddedMonth}`;
    }

    displayPolicyGroup(option: any): string {
        return option?.name || '';
    }

    onPolicyGroupChange(selectedId: number | null): void {
        this.selectedPolicyGroupId = selectedId ?? undefined;
    }

    onPeriodChange(selectedId: number | null): void {
        this.selectedPeriodId = selectedId ?? undefined;
    }

    onRunReport(form: any): void {
        this.formSubmitted = true;

        if (!form.valid || !this.selectedPolicyGroupId || !this.selectedPeriodId) {
            return;
        }

        const selectedPeriod = this.periods.find(period => period.id === this.selectedPeriodId);
        const selectedPolicyGroup = this.policyGroups.find(group => group.id === this.selectedPolicyGroupId);

        const reportParams = [
            new ReportParameter(0, 'Policy Group', this.selectedPolicyGroupId, selectedPolicyGroup
                ? `${selectedPolicyGroup.name}`
                : ''),

            new ReportParameter(1, 'Period', this.selectedPeriodId, selectedPeriod
                ? new Date(selectedPeriod.year, selectedPeriod.month - 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
                : ''),
        ];

        this.router.navigate(['/report-viewer', ReportConstants.SharedDebtorByPolicyReport], {
            state: {
                reportParams
            }
        });
    }
}